import { render, staticRenderFns } from "./DefiRepay.vue?vue&type=template&id=6caf123e&"
import script from "./DefiRepay.vue?vue&type=script&lang=js&"
export * from "./DefiRepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports